import { format } from "date-fns";

/** Standard UI date-time display: Aug 04, 2026, 10:55 AM */
export const APP_DISPLAY_DATE_FORMAT = "MMM dd, yyyy, h:mm a";

export function isValidDate(date) {
  if (date === null || date === undefined || date === "") return false;
  const parsedDate = new Date(date);
  return !isNaN(parsedDate.getTime());
}

/** API / form date string: yyyy-MM-dd */
export function getFormattedDate(dateValue) {
  const date = isValidDate(dateValue) ? new Date(dateValue) : new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

/**
 * Standard display datetime used across the app.
 * Accepts Date, ISO string, or epoch millis.
 * Returns empty string for invalid/empty values.
 */
export function getFormattedDateTime(dateValue) {
  if (dateValue === null || dateValue === undefined || dateValue === "") {
    return "";
  }
  if (!isValidDate(dateValue)) {
    return "";
  }
  return format(new Date(dateValue), APP_DISPLAY_DATE_FORMAT);
}

export function getDaysByFrequency(frequency) {
  switch (frequency?.toLowerCase()) {
    case "weekly":
      return 7;
    case "monthly":
      return 30;
    case "quarterly":
      return 90;
    case "yearly":
      return 365;
    default:
      throw new Error("Invalid frequency");
  }
}

export function getFrequencyByDays(days) {
  if (typeof days !== "number" || days < 0) {
    return "";
  }

  if (days <= 7) {
    return "weekly";
  } else if (days <= 30) {
    return "monthly";
  } else if (days <= 90) {
    return "quarterly";
  } else {
    return "yearly";
  }
}
